module.exports = __webpack_public_path__ + "img/yumiICON.0c85ed7f.png";